<template>
  <div class="order">
    <div class="order__content">
      <div class="order-text">
        <div class="order-text__header">
          <BaseHeading :size="1">{{heading}}</BaseHeading>
        </div>
        <BaseText>
          <p v-for="(item, n) in textList" :key="n" v-html="item"></p>
        </BaseText>
        <div class="order-text__mail" v-if="!finished">
          <BaseButton color="black" buttonText="Beställ här" @click="openMail"/>
        </div>

        <div class="order-text__mail-address">order@fjallkott.se</div>
                <BaseText>
          <p>Leverans sker i november 2026</p>
        </BaseText>
      </div>
      <div class="order-box">
        <div class="order-box__header">
          <BaseHeading :size="4" color="red">{{boxContent.heading}}</BaseHeading>
        </div>
        <div class="order-box__top">
          <BaseText>
            <p v-for="(item, n) in boxContent.textList" :key="n">
             {{item}}
            </p>
          </BaseText>
        </div>
        <div class="order-box__included">
          <ul>
            <li class="order-box__included__entry" v-for="(item, n) in boxContent.boxItems" :key="n">- {{item}}</li>
          </ul>
        </div>
        <div class="order-box__bottom">
          <div class="order-box__bottom__header">
            <BaseHeading :size="5" color="black">{{boxContent.bottomHeading}}</BaseHeading>
          </div>
          <BaseText>
            <p v-for="(item, n) in boxContent.textListBottom" :key="n">
             {{item}}
            </p>
          </BaseText>
        </div>
      </div>
      <div class="order-box-image">
          <div class="order-box-image__header">
            <BaseHeading :size="2">En låda renkött</BaseHeading>
          </div>
          <img src="/static/images/a_box_of_reindeer_meat.jpg" class="order-box-image__img"/>
      </div>

      <div class="order-text__mail-bottom" v-if="!finished">
        <BaseButton color="black" buttonText="Beställ här" @click="openMail"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SectionOrder',
  data () {
    return {
      finished: false
    }
  },
  props: {
    textContent: Object,
    boxContent: Object
  },
  methods: {
    openMail () {
      window.location.href = 'mailto:order@fjallkott.se?subject=Beställning 2026 - Fjällkött&body=' + this.mailtoBody
    }
  },
  computed: {
    mailtoBody: function () {
      let str = 'För att beställa ange:%0D%0A%0D%0A'
      str += 'Fullständigt namn:%0D%0A%0D%0A'
      str += 'Adress:%0D%0A%0D%0A'
      str += 'Telefon:%0D%0A%0D%0A'
      str += 'Mejl:%0D%0A%0D%0A'
      str += 'Antal lådor: 1 %0D%0A%0D%0A%0D%0A%0D%0A'
      str += 'Skicka sen mejlet till oss. Beställningar är bindande. Vi kontaktar dig strax innan leverans.%0D%0A%0D%0A'
      str += '%0D%0A%0D%0AEn låda innehåller:%0D%0A%0D%0A'
      this.boxContent.boxItems.forEach(item => {
        str += `${item}%0D%0A`
      })
      str += '%0D%0A%0D%0A'
      this.boxContent.textListBottom.forEach(item => {
        str += `${item}%0D%0A`
      })
      return str
    },
    heading: function () {
      return this.finished ? 'Vi tackar alla som beställt 2026!' : this.textContent.heading
    },
    textList: function () {
      return this.finished ? ['Vi levererar alltid färskt renkött en gång per år i efter att årets slakt genomförts', 'Till er som beställt renkött. Någon vecka innan leverans kommer ett leveransbesked med exakt tid och datum för leverans.'] : this.textContent.textList
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './section-order'
</style>



// WEBPACK FOOTER //
// src/views/ViewOrder/components/SectionOrder/SectionOrder.vue